import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "../../common/Button";
import { downloadTestFeedback, testFeedbackUrl } from "../../api/profileApi";
import {
  isDownloadAttrSupported,
  forceDownload,
} from "../../containers/ResourceFolders/util";

const downloadFeedback = async (testName) => {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(testName).then((response) =>
      forceDownload(response, "Exposure_Based_Memory_Test_Feedback_Fields.pdf")
    );
  }
  return window.open(testFeedbackUrl(testName), "_blank");
};
const ExposureBasedMemoryTestIndex = ({ appData }) => {
  return (
    <article>
      <div className="styles__resource__wrapper___EooDq">
        <h4 className="styles__resource__title___3swKq">
          Exposure Based Memory Test
        </h4>
        <p className="styles__resource__description___2yhR0">
          <b>
            The human brain has a special module that is used to recognize
            faces. Some people have to use information such as hair, voice, and
            body to recognize others as every time they see a face, it is like
            they have never seen that face before.
            <br />
            <br />
            The Exposure Based Face Memory Test was developed as a measure of
            face memory and was designed to replicate face memory experienced in
            every day life.
            <br />
            <br />
            In this test you will be shown a long series of faces. For each face
            you must say if you have been shown that person before, or if this
            is a new face you have not been shown yet. It should take 2-5
            minutes to complete. This test can only be taken once.
            <br />
            <br />
            This test is provided for educational use only. It should not be
            used as psychological advice of any kind and comes without any
            guarantee of accuracy or fitness for any particular purpose.
            <br />
            <br />
            In taking this test, you consent to HRGO storing and processing the
            information you provide in order to provide you with the test
            result. The information you provide may also be used to find the
            most suitable job for you, to share with clients, train our data
            models, improve and iterate these tests, and provide you with the
            most relevant advertising and courses. Where the data does not
            require attribution; we will anonymise your information for
            processing.
            <br />
            <br />
            {appData.exposureBasedMemoryTestHandling
              ? " Please click Download to get your feedback."
              : " Please click Launch to complete this test."}
          </b>
        </p>
        <div className="d-flex flex-column">
          {appData.exposureBasedMemoryTestHandling ? (
            <Button
              onClick={() => {
                downloadFeedback("exposureBasedMemory");
              }}
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary ml-auto"
            >
              Download
            </Button>
          ) : (
            <Link
              to="/profile/MyTests/ExposureBasedMemory"
              className="btn btn-primary ml-auto"
            >
              Launch
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, null);
export default withRedux(ExposureBasedMemoryTestIndex);
